import { gql } from '@apollo/client'
import { useCleanFilterForRequest, useSearch, useSort } from '@btime/react-contexts'
import React, { createContext, useContext } from 'react'

import { triggersClient } from '../../../../../utils/apollo/api'
import { useModalData } from '../../../../../components/modals/ModalsContext'
import { usePaginatedQuery } from '../../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../../packages/kiti/components/helpers/LazyAction'
import StatePresenter from '../../../../../packages/kiti/components/helpers/StatePresenter'

const Context = createContext()
const { Provider } = Context
export const useFoldersState = () => useContext(Context) || {}
export const useFolders = () => useFoldersState()?.folders || []

const QUERY = gql`
  query Folders($page: Int, $search: String, $sort: FolderSort, $filter: FolderFilter) {
    folders(page: $page, search: $search, sort: $sort, filter: $filter) {
      id
      name
      triggersCount
      default
    }
  }
`

const TriggersFoldersLoader = ({ children, uncontrolledChildren }) => {
  const { field, type } = useSort()
  const search = useSearch()
  const filter = useCleanFilterForRequest()
  const { entities } = useModalData() || {}

  const { data, fetchMore, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      search,
      sort: { field: field || 'INSERTED_AT', type: type || 'ASC' },
      filter: {
        entities,
        routinesOnly: true,
        ...filter
      }
    },
    client: triggersClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={data?.folders?.length <= 1 || state.loading || state.isFetchingMore} />
      </StatePresenter>
    </Provider>
  )
}

export default TriggersFoldersLoader
